import * as modules from "./modules";
import config from "../../../../config";
const { vendor } = config;

const LocalizedRouteRedirect = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default LocalizedRouteRedirect;
